<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnPowerSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Eigen vermogen')"
                         :calculated-value="data.calculated.balance_passive_business_assets_equity"
                         v-model="data.edit.balance_passive_business_assets_equity"/>

      <TaxReturnTableRow :description="$gettext('Egalisatiereserve')"
                         :calculated-value="data.calculated.balance_passive_business_assets_equalisation_reserve"
                         v-model="data.edit.balance_passive_business_assets_equalisation_reserve"/>

      <TaxReturnTableRow :description="$gettext('Herinvesteringreserve')"
                         :calculated-value="data.calculated.balance_passive_business_assets_reinvest_reserve"
                         v-model="data.edit.balance_passive_business_assets_reinvest_reserve"/>

      <TaxReturnTableRow :description="$gettext('Oudedagsreserve')"
                         :calculated-value="data.calculated.balance_passive_business_assets_old_age_reserve"
                         v-model="data.edit.balance_passive_business_assets_old_age_reserve"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>